// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const foodNutrientTypeId = (z.number());
export const foodNutrientType = z.object({
    id: foodNutrientTypeId,
    name: z.string(),
    default_unit: z.string(),
    created_at: z.date().nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const foodNutrientTypeInitializer = z.object({
    id: foodNutrientTypeId.optional(),
    name: z.string(),
    default_unit: z.string().optional(),
    created_at: z.date().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const foodNutrientTypeMutator = z.object({
    id: foodNutrientTypeId.optional(),
    name: z.string().optional(),
    default_unit: z.string().optional(),
    created_at: z.date().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FoodNutrientType.js.map